"use client";
import * as React from "react";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import styles from "./ModeOfCommunication.module.css";
import GmailImage from "../../assets/modeOfCommunication/gmailextra.png";
import InstagramImage from "../../assets/modeOfCommunication/instagram.png";
import LinkdinImage from "../../assets/modeOfCommunication/linkedin.png";
import FacebookImage from "../../assets/modeOfCommunication/facebook.png";
import WhatsappImage from "../../assets/modeOfCommunication/whatsapp.png";

function ModeOfCommunication() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 120,
    });
  }, []);

  return (
    <section className={styles.modeofCommunication}>
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          <p className={styles.quote} data-aos="fade-up">
            &quot;Innovate, Build, Transform – Your Vision, Our Expertise!&quot;
          </p>
          <h1 className={styles.heading} data-aos="fade-up">
            Ways to Connect with Us
          </h1>

          <div className={styles.iconContainer} data-aos="zoom-in">
            <a
              href="https://www.linkedin.com/company/105639071/admin/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={LinkdinImage}
                alt="LinkedIn"
                className={styles.communicationIcon}
              />
            </a>

            <a
              href="https://www.instagram.com/starlinklab/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={InstagramImage}
                alt="Instagram"
                className={styles.communicationIcon}
              />
            </a>

            <a
              href="mail.google.com/mail/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={GmailImage}
                alt="Gmail"
                className={styles.communicationIcon}
              />
            </a>

            <a
              href="https://www.facebook.com/starlinklab"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={FacebookImage}
                alt="Facebook"
                className={styles.communicationIcon}
              />
            </a>

            <a
              href="https://web.whatsapp.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={WhatsappImage}
                alt="WhatsApp"
                className={styles.communicationIcon}
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ModeOfCommunication;
